<template lang="pug">
  .coach-list-item
    .coach-list-item-content
      f7-link(
        href="#"
        class="item-link"
        @click="$emit('click', $event)")
        coach-avatar-list(:src="coach.avatarImageUrl" :is-overload="!coach.isAcceptableNewStudent" :is-new="coach.checkIsNew")
        p.coach-name {{ coach.name }}
        p.price {{ monthlyFee }}
        p.dance-kinds {{ coach.localeSupportedDanceKinds.join(', ') }}
      template(v-if="coach.reviewCount == 0")
        coach-review-list(
          class="no-review"
          :rating="coach.reviewRateAverage"
          :reviewCount="coach.reviewCount")
      template(v-else)
        f7-link(
          href="#"
          class="item-link"
          @click="$emit('reviewClick', $event)")
          coach-review-list(
            :rating="coach.reviewRateAverage"
            :reviewCount="coach.reviewCount"
            @click="$emit('reviewClick', $event)")

</template>

<style lang="scss" scoped>
.coach-list-item {
  width: calc(100% / 2 - 1.5px);
  margin-bottom: 20px;
  text-align: center;
  display: flex;
  overflow: hidden;

  .coach-list-item-content {
    .item-link,
    .no-review {
      flex-direction: column;
      text-align: center;
      align-items: center;
      justify-content: center;
      width: 100%;

      p {
        margin: 0;
        padding: 0;
      }

      .coach-name {
        @extend %title;
        margin: 12px 0;
        line-height: 15px;
      }

      .dance-kinds {
        @extend %label-text;
        line-height: 140%;
        font-weight: normal;
        margin-top: 12px;
        height: 32px;
        display: flex;
        align-items: center;
      }

      .price {
        @extend %title;
        font-size: 12px;
      }
    }
  }
  .coach-review-list {
    margin-top: 12px;
    display: flex;
  }
}
</style>

<script>
import CoachAvatarList from '@/components/atoms/CoachAvatarList'
import CoachReviewList from '@/components/atoms/CoachReviewList'
import Formatter from '@/components/mixins/Formatter'

export default {
  components: {
    CoachAvatarList,
    CoachReviewList,
  },
  mixins: [Formatter],
  props: {
    coach: {
      type: Object,
      required: true,
    },
  },
  computed: {
    monthlyFee() {
      if (this.coach.monthlyFee) {
        return `¥${this.numberToCurrency(this.coach.monthlyFee)} / 月`
      }
      return '-'
    },
  },
}
</script>
